export default __webpack_public_path__ + "static/media/logo.22a50406.png";